import React from 'react';
import { motion } from 'framer-motion';
export function ForWhom() {
  const profiles = [{
    title: 'Veterinario/a recién recibido/a',
    desc: 'Tenés la formación clínica pero no los protocolos de comunicación para el día a día real del consultorio.',
    isNew: false
  }, {
    title: 'Veterinario/a con experiencia media',
    desc: 'Sabés diagnosticar y tratar — pero hay conversaciones que todavía te cuestan y te desgastan innecesariamente.',
    isNew: false
  }, {
    title: 'Dueño/a de clínica veterinaria',
    desc: 'Querés estandarizar los protocolos de tu equipo y que todos atiendan con el mismo nivel de comunicación.',
    isNew: true
  }, {
    title: 'Veterinario/a de pequeños animales',
    desc: 'Atendés perros y gatos — y sabés que el dueño es tan parte del caso clínico como el animal.',
    isNew: false
  }];
  return <section className="bg-navy py-10 sm:py-16 px-5" data-id="element-116">
      <div className="max-w-6xl mx-auto" data-id="element-117">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-gold-light mb-2 sm:mb-3" data-id="element-118">
          ¿Para quién es?
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-white mb-8 sm:mb-12 leading-tight" data-id="element-119">
          Diseñado para vos si querés
          <br className="hidden sm:block" data-id="element-120" />
          ejercer con seguridad y confianza
        </h2>

        <div className="grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5" data-id="element-121">
          {profiles.map((profile, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.4
        }} whileHover={{
          background: 'rgba(255,255,255,0.1)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-white/6 border border-white/10 rounded-xl p-4 sm:p-6 transition-colors cursor-default" data-id="element-122">
              {profile.isNew && <span className="inline-block bg-gold text-navy text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider mb-2" data-id="element-123">
                  NUEVO
                </span>}
              <h4 className="font-semibold text-sm sm:text-base text-white mb-1.5 sm:mb-2" data-id="element-124">
                {profile.title}
              </h4>
              <p className="text-[11px] sm:text-sm text-white/60 leading-relaxed" data-id="element-125">
                {profile.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}